<template>
  <v-card outlined>
    <v-data-table
      :loading="loading"
      :items="industries"
      :headers="headers"
      :items-per-page="1000"
      hide-default-footer
      :sort-by="['name']"
      :sort-desc="[false]"
      :search="filter.search"
      mobile-breakpoint="0"
    >
      <template #[`item.popularity.ranking`]="{ item }">
        <v-select
          v-if="item.popularity"
          v-model="item.popularity.id"
          :items="popularity"
          outlined
          hide-details
          item-value="id"
          item-text="name"
          class="min-width"
          dense
          @change="savePopularity(item)"
        />
      </template>
      <template #[`item.publishedCount`]="{ item }">
        {{ item.publishedCount | separator }}
      </template>
      <template #[`item.notPublishedCount`]="{ item }">
        {{ item.notPublishedCount | separator }}
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          class="mr-2"
          outlined
          @click="rowClick(item)"
        >
          Filter
        </v-btn>
        <v-btn :to="`/industries/${item.id}`"> Edit </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'CatalogIndustries',
  components: {},
  data: () => {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Popularity', value: 'popularity.ranking' },
        { text: 'Published', value: 'publishedCount' },
        { text: 'Not Published', value: 'notPublishedCount' },
        { text: '', value: 'actions', sortable: false }
      ],
      loading: false
    };
  },
  computed: {
    filter: {
      get() {
        return this.$store.getters['catalog/filter'];
      },
      set(val) {
        this.$store.dispatch('catalog/filter', val);
      }
    },
    ...mapGetters({
      industries: 'industries/list',
      popularity: 'lookup/popularity'
    })
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch('industries/load', this.filter)
      .catch((error) => {
        this.logError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    rowClick(item) {
      this.$store
        .dispatch('catalog/filter', Object.assign(this.filter, { industryId: item.id }))
        .then(() => {
          this.$router.push({ path: '/catalog/topics' });
        });
    },
    savePopularity(item) {
      this.saving = true;
      this.$store
        .dispatch('industries/savePopularity', {
          id: item.id,
          popularityId: item.popularity.id
        })
        .then(() => {
          this.$root.$snackbarSuccess('Popularity saved');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
